import { action, computed, makeObservable, observable } from 'mobx';
import toast from 'react-hot-toast';
import URLConstants from '../../constants/url-constants';
import config from '../../helpers/config-helper';
import IApiResponse, {
  IApiSuccessResponse,
} from '../../models/response/IApiResponse';
import { formatMessage } from '../../translations/format-message';
import {
  GetUserLogInitialState,
  ObservableInitialState
} from '../initialState';
import * as baseService from '../service/base-service';
import { IUserLogsState } from '../../models/state/IUserLogState';
import { IUserLogList, IUsersLogListVM, IUsersLogVM } from '../../models/response/IUsersLogResponse';
import { fixTimezoneOffsetYYYYMMDDWithTimeStamp } from '../../constants/constants';
import { de } from 'date-fns/locale';
const appConfig = config();

interface IColumnProps {
  ShortName: string;
  IsHidden: boolean;
}

export class UserLogsStore implements IUserLogsState {
  initialStateValue = ObservableInitialState;
  userLogList: IUsersLogListVM = GetUserLogInitialState;
  userLog: IUsersLogVM | undefined = undefined;
  userLogState = { ...this.initialStateValue };
  getAllUserLogsState = { ...this.initialStateValue };
  checkedColumns: IColumnProps[] = [];

  constructor() {
    makeObservable(this, {
      userLog: observable,
      userLogState: observable,
      userLogList: observable,
      getAllUserLogsState: observable,
      GetUserLogsListService: action,
      reset: action,
      allProcess: computed
    });
  }

  //#region Actions
  GetUserLogsListService = (Data :any
  ) => {
    this.getAllUserLogsState.inProgress = true;
    const url =
      URLConstants.UserLogs + "/UserLog"
    return baseService
      .postRequest(url, Data)
      .then((response: IApiResponse<IApiSuccessResponse<IUsersLogListVM>>) => {
        if (response.data.Error) {
          this.getAllUserLogsState.error = response.data.Message;
          toast.error(formatMessage(response.data.Message));
        } else {
          this.userLogList = response.data.Data;
          this.getAllUserLogsState.success = true;
        }
      })
      .catch((err: string) => {
        this.getAllUserLogsState.error = err;
      })
      .finally(
        action(() => {
          this.getAllUserLogsState.inProgress = false;
        })
      );
  };

  GetUserLogsByIdService = (id: number) => {
    this.userLogState.inProgress = true;
    let url = URLConstants.UserLogs + '/User/' + id;
    return baseService
      .getRequest(url)
      .then((response: IApiResponse<IApiSuccessResponse<IUsersLogVM>>) => {
        if (response.data.Error) {
          this.userLogState.error = response.data.Message;
        } else {
          this.userLog = response.data.Data;
        }
      })
      .catch((err: string) => {
        this.userLogState.error = err;
      })
      .finally(
        action(() => {
          this.userLogState.inProgress = false;
        })
      );
  };


  get allProcess(): IUserLogList[] {
    let processData: IUserLogList[] = [];
    if (this.userLogList?.Logs && this.userLogList?.Logs?.length > 0) {
      this.userLogList.Logs.map((userLog) => {
        return processData.push({
            Id: userLog.Id,
            UserId: userLog.UserId,
            UserName: userLog.UserName,
            Action: userLog.Action,
            Factory: userLog.Factory || '--',
            Module: userLog.Module,
            ActionDetail: userLog.ActionDetail,
            ActionDateTime: fixTimezoneOffsetYYYYMMDDWithTimeStamp(userLog.ActionDateTime),
            ActionId: userLog.ActionId,
        });
      });
    }
    return processData;
  }

  get userLogsDetails(): IUsersLogVM {
    if (this.userLog) {
      return {
        Id: this.userLog.Id,
        UserId: this.userLog.UserId,
        UserName: this.userLog.UserName,
        Action: this.userLog.Action,
        Factory: this.userLog.Factory,
        Module: this.userLog.Module,
        ActionDetail: this.userLog.ActionDetail,
        ActionDateTime: fixTimezoneOffsetYYYYMMDDWithTimeStamp(this.userLog.ActionDateTime),
        //ActionDateTime: this.userLog.ActionDateTime,
        ActionId: this.userLog.ActionId,
      };
    }
    return {
      Id: -1,
      UserId: -1,
      UserName: '',
      Action: '',
      Factory: '',
      Module: '',
      ActionDetail: '',
      ActionDateTime: null,
      ActionId: -1,
    };
  }

  reset = () => {
    this.userLogList = GetUserLogInitialState;
  };

  resetProcessDetail = () => {
    this.userLog = undefined;
    this.userLogState = { ...this.initialStateValue };
  };
}

export default new UserLogsStore();
